/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice\src\Services\Offer\offer.service.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice
 * Created Date: Monday June 24th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday, 25th September 2024 02:42:29
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import ServiceGeneral from "Services/ServiceGeneral";

export default class OfferService {
    static makeReservation(carID: string) {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFERS}`;
        return ServiceGeneral.manageCall(url, "post", {carID});
    }

    static getMyOffers() {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFERS}/current`;
        return ServiceGeneral.manageCall(url, "get");
    }

    static getMyBoughtCars() {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFERS}/bought`;
        return ServiceGeneral.manageCall(url, "get");
    }
}
